

import {doGetRequest, doPostRequest, doPutRequest, doDeleteRequest} from '../../../tools/axios_';
import { Utils } from '../../../tools/utils';

/**
 * 入职列表查询
 **/
export const findEntryList = async (orgId, companyId, page, limit) => {
    return await doGetRequest({
        url: '/api/market/entry/apply/list',
        params: {
            orgId,
            companyId,
            page,
            limit
        }
    });
}
// 机构树
export const getCompanyTreeList = async (companyName,orgId = Utils.getOrgId()) => {
    return await doGetRequest({
        url: '/api/organization/orgCompany/getCompanyTreeList',
        params: {
            companyName,
            orgId,
            companyId: Utils.getCompanyId(),
            companyLevelId: Utils.getCompanyLevelId(),
        }
    });
};

/**
 * 保司工号列表查询
 */
export const findJobNumberList = async ({
    orgId, // ": "商户ID",
    insuranceCompanyId, // : "保险公司ID",
    applyStatus, // ": "申请状态（1:申请中  2:开通中 3:申请成功 4:申请失败 5:注销中 6:已失效）",
    salesmanName, // : "业务员名称或手机号",
    agencyCompanyId, // ": "代理公司Id",
    jobNumber, // : "保司工号",
    companyId, // : "机构ID",
    pageNum, // : "页码",
    pageSize, // ": "页数"
} = data) => {
    return await doPostRequest({
        url: '/api/organization/merchantJobNumber/org/findList',
        data: {
            orgId, // ": "商户ID",
            insuranceCompanyId, // : "保险公司ID",
            applyStatus, // ": "申请状态（1:申请中  2:开通中 3:申请成功 4:申请失败 5:注销中 6:已失效）",
            salesmanName, // : "业务员名称或手机号",
            agencyCompanyId, // ": "代理公司Id",
            jobNumber, // : "保司工号",
            companyId, // : "机构ID",
            pageNum, // : "页码",
            pageSize, // ": "页数"
        }
    });
}

/**
 * 保司工号列表查询
 */
 export const findJobListByPage = async ({
    orgId, // ": "商户ID",
    companyId, // : "机构ID",
    insuranceCompanyId, // : "保险公司ID",
    salesmanName, // 业务员名称或手机号
    agencyCompanyId, // ": "代理公司Id",
    applyStatus, // ": "申请状态（1:申请中  2:开通中 3:申请成功 4:申请失败 5:注销中 6:已失效）",
    jobNumber, // : "保司工号",
    pageNum, // : "页码",
    pageSize, // ": "页数"
    practiceAreaCode,// 执行区域code
} = data) => {
    return await doPostRequest({
        url: '/api/organization/merchantJobNumber/org/listByPage',
        data: {
            orgId, // ": "商户ID",
            companyId, // : "机构ID",
            insuranceCompanyId, // : "保险公司ID",
            agencyQueryKeyword:salesmanName, // 业务员名称或手机号
            agencyCompanyId, // ": "代理公司Id",
            applyStatus:applyStatus, // ": "申请状态（1:申请中  2:开通中 3:申请成功 4:申请失败 5:注销中 6:已失效）",
            jobNumber, // : "保司工号",
            pageNum, // : "页码",
            pageSize, // ": "页数"
            practiceAreaCode,// 执行区域code
        }
    });
}



/**
 * 保司工号注销
 */

export const isCancelJobNumber = async (merchantJobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/cancelJobNumber',
        params:{
            merchantJobNumberId,
            source:'org'
        }
    });
}


/**
 * 商户工号注销
 */

export const jobNumberCancellation = async (jobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/insuranceCompanyNumber/cancellationJobNumber',
        params: {
            jobNumberId,
            jobNumberType: '1'
        }
    });
}


/**
 * 查询代理公司名称
 */
export const findAgencyCompanyList = async () => {
    return await doGetRequest({
        url: '/api/market/entry/apply/company'
    });
}

/**
 * 查询代理公司名称（申请上号）
 */
export const findAgencyCompanyList2 = async () => {
    return await doGetRequest({
        url: '/api/organization/agencyCompany/findAgencyCompanyList'
    });
}

/**
 * 查询保险公司（申请上号）（商户下对应代理公司对接的产品未申请开通工号的保司数据）
 */
export const findNonAppliedInsuranceCompanyList = async (orgId, agencyCompanyId, merchantJobNumberId) => {
    return await doPostRequest({
        url: '/api/organization/insuranceCompanyNumber/org/findNonAppliedInsuranceCompanyList',
        data: {
            orgId,
            agencyCompanyId,
            merchantJobNumberId, // 有就传没有就不传
            companyId: Utils.getCompanyId()
        }
    });
}


/**
 * 申请工号
 * @param orgId 机构ID
 * @param agencyCompanyId 代理人公司ID
 * @param agencyCompanyName 代理人公司Name
 * @param salesmanName 业务员名称
 * @param agencyMobile 业务员手机号
 * @param insuranceCompanyIdList 保险公司LIST
 * @param companyId 商户ID
 * @param userId 业务员ID
 */
export const applyJobNumber = async ({ orgId, agencyCompanyId, agencyCompanyName, salesmanName, agencyMobile, insuranceCompanyIdList, companyId, userId, merchantJobNumberId }) => {
    return await doPostRequest({
        url: '/api/organization/merchantJobNumber/applyJobNumber',
        data: {
            orgId,
            agencyCompanyId,
            agencyCompanyName: agencyCompanyName || agencyCompanyName,
            salesmanName: salesmanName || '',
            userId,
            insuranceCompanyIdList,
            companyId,
            agencyMobile,
            merchantJobNumberId
        }
    });
}

/**
 * 申请工号
 * @param agencyCompanyId 代理人公司ID
 * @param agencyId 代理ID
 * @param insuranceCompanyIdList 保险公司LIST
 * @param electronicSignatureUrl 签名成功的图片地址
 */
export const applyJobNumberV2 = async ({ agencyCompanyId,agencyId,insuranceCompanyIdList,electronicSignUrl }) => {
    return await doPostRequest({
        url: '/api/organization/merchantJobNumber/applyJobNumber/v2',
        data: {
            agencyCompanyId,
            agencyId,
            insuranceCompanyIdList,
            electronicSignUrl
        }
    });
}

/**
 * 生成电子签名短链接
 * @param agencyId 代理ID
 */
 export const getShortUrl = async (agencyId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/electronicSign/getShortUrl',
        params: {
            agencyId,
        }
    });
}


/**
 * 获取电子签名结果
 * @param agencyId 代理ID
 */
 export const getSignResult = async (agencyId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/electronicSign/getResult',
        params: {
            agencyId,
        }
    });
}

/**
 * 重试申请
 * @param merchantJobNumberId 商户工号ID
 */
 export const retryApply = async (merchantJobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/retryApply',
        params: {
            merchantJobNumberId
        }
    });
}
/**
 * 查询商户工号详情
 * @param merchantJobNumberId 商户工号ID
 */
 export const findDetailByJobNumberIdV2 = async (merchantJobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/findDetailByJobNumberId/v2',
        params: {
            merchantJobNumberId,
        }
    });
}


/**
 * 代理公司查询（商户下有数据代理公司）
 */
 export const findAgencyCompanyListv2 = async (orgId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/org/findAgencyCompanyList',
        params: {
            orgId
        }
    });
}

/**
 * 保险公司查询（商户下有数据保险公司）
 */
export const findOrgInsuranceCompanyList = async (orgId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/org/findOrgInsuranceCompanyList',
        params: {
            orgId
        }
    });
}

/**
 * 查询执业区域筛选列表
 */
export const findPracticeAreaList = async (orgId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/org/findPracticeAreaList',
        params: {
            orgId
        }
    });
}

/**
 * 查询商户工号详情
 * @param merchantJobNumberId 商户工号ID
 */
export const findDetailByJobNumberId = async (merchantJobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/findDetailByJobNumberId',
        params: {
            merchantJobNumberId,
        }
    });
}

/**
 *
 * 查询业务员姓名（申请上号）
 * @param orgId 机构ID
 * @param agencyCompanyId 代理公司ID
 * @param agencyCompanyName 代理公司名称
 * @param salesmanName 业务员名称模糊查询
 */
export const findEmployedAgencyLis = async ({ orgId, agencyCompanyId, agencyCompanyName, salesmanName }) => {
    return await doPostRequest({
        url: '/api/organization/insuranceCompanyNumber/org/findEmployedAgencyList',
        data: {
            orgId,
            agencyCompanyId,
            agencyCompanyName: agencyCompanyName,
            salesmanName: salesmanName || ''
        }
    });
}
/**
 *
 * 查询业务员姓名（申请上号）
 * @param orgId 机构ID
 * @param agencyCompanyId 代理公司ID
 */
export const getAgencyByAgencyCompanyId = async (data) => {
    return await doPostRequest({
        url: '/api/organization/agencyCompany/getAgencyByAgencyCompanyId',
        data,
    });
}

/**
 * 查询业务员当前代理公司可上号的保司列表
 * @param orgId 机构ID
 * @param agencyCompanyId 代理公司ID
 */
 export const getAgencyValidInsuranceCompanyList = async (orgId, agencyCompanyId,agencyId,insuranceCompanyId) => {
    return await doGetRequest({
        url: '/api/organization/insuranceCompany/getAgencyValidInsuranceCompanyList',
        params: {
            orgId,
            agencyCompanyId,
            agencyId,
            insuranceCompanyId:insuranceCompanyId||''
        }
    });
}



/**
 * 代理公司查询（商户下有数据代理公司）
 */
export const findAgentCompanyList = async (orgId, companyId) => {
    return await doGetRequest({
        url: '/api/organization/insuranceCompanyNumber/org/findAgencyCompanyList',
        params: {
            orgId, companyId
        }
    });
}

/**
 * 保险公司查询（商户下有数据保险公司）
 */
export const findInsuranceCompanyList = async (orgId, companyId) => {
    return await doGetRequest({
        url: '/api/organization/insuranceCompanyNumber/org/findInsuranceCompanyList',
        params: {
            orgId, companyId
        }
    });
}


/**
 * 获取入职短链-新
 * @param companyCode 获取入职公司列表返回的code值
 */
export const getIntoLink = async (companyCode) => {
    return await doPostRequest({
        url: '/api/market/entry/apply/bind/url',
        data: {
            companyCode
        }
    });
}

/**
 * 获取修改信息短链-新
 * @param agencyEntryId 列表返回的id字段
 * @returns {Promise<unknown>}
 */
export const accessToModifyLink = async (agencyEntryId) => {
    return await doPostRequest({
        url: '/api/market/entry/apply/change/url',
        data: {
            agencyEntryId
        }
    });
}


/**
 * 获取商户合规信息
 * @param orgId 机构信息
 * 可以不传，doGetRequest方法中会自动拼上当前商户的orgId
 */
export const getCorrectRegulations = async (orgId) => {
    return await doGetRequest({
        url: '/api/organization/orgInfoExtend/getcCorrectRegulations',
        params: {
            orgId
        }
    });
}

/**
 * 保司工号修改
 */

 export const modifyJobNumber = async (merchantJobNumberId,
    agencyCompanyId,
    agencyId,
    electronicSignUrl,
    insuranceCompanyId,agencyCustomizeJobCode) => {
    return await doPostRequest({
        url: '/api/organization/merchantJobNumber/modifyJobNumber',
        data: {
            merchantJobNumberId,
            agencyCompanyId,
            agencyId,
            electronicSignUrl,
            insuranceCompanyId,
            agencyCustomizeJobCode
        }
    });
}

/**
 * 查询当前业务员已申请保司集合
 * @param agencyId 机构信息
 */
export const getInsuranceList = async (agencyId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/agency/apply/insurance/list',
        params: {
            agencyId
        }
    });
}


/**
 * 查询当前业务员已申请保司集合
 * @param agencyCustomizeJobCode 机构信息
 */
export const getInsuranceIDRepeat = async (agencyCustomizeJobCode,merchantJobNumberId) => {
    return await doGetRequest({
        url: '/api/organization/merchantJobNumber/agency/customize/repeat',
        params: {
            agencyCustomizeJobCode,
            merchantJobNumberId
        }
    });
}

